export default "__VITE_ASSET__CWZSZgnq__"